"use strict";
/*
 * Created on 2019-04-11
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../../core/conversions/DataObjectConverter");
/**
 * @author Radek Beran
 */


var SelloutImpactRecordSumsConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(SelloutImpactRecordSumsConverter, _DataObjectConverter_);

  function SelloutImpactRecordSumsConverter() {
    _classCallCheck(this, SelloutImpactRecordSumsConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(SelloutImpactRecordSumsConverter).apply(this, arguments));
  }

  return SelloutImpactRecordSumsConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.SelloutImpactRecordSumsConverter = SelloutImpactRecordSumsConverter;